<template>
  <section class="sec-top-intro">
    <div class="box-top-slide">
      <div class="img-top-slide">
        <img src="@/assets/img/column/202502_01.jpg" />
      </div>
      <div class="img-top-slide_text">
        <h2 class="mb-0 text-left"><span>エイジングケアにおすすめの成分</span><br>「ナイアシンアミド」と「ビタミンC誘導体」</h2>
      </div>
    </div>
  </section>

  <section class="column_content">
    <h2 class="my-5 pt-5">【9割の皮膚科医・美容ナースが警鐘！】<br>紫外線による肌ダメージは深刻。対策の鍵は「エイジングケア」</h2>
    <p class="text-center mb-5 pb-5">一般的に<br><strong>『紫外線対策をしっかり行うことで将来的なエイジングケアにもつながること』</strong><br>が理解されていない？！</p>
    <div class="feature-row">
      <div class="feature-row_item_image w-50">
        <img src="@/assets/img/column/202502_02.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-50">
        <h3 class="mb-3">紫外線対策とエイジングケアの関係。</h3>
        <p class="mb-3"><strong>「シミ・シワ」を予防するために「紫外線対策」</strong>を意識する方は女性も男性も多いと思いますが、なんとなく自分事化していない方も多いかもしれない<strong>「エイジングケア」</strong>。</p>
        <p class="mb-3">一般的に「エイジングケア」と聞くと、大人向け・女性向けのイメージかもしれませんが、実は<strong>『年齢に応じた、肌のケア』</strong>を意味しています。</p>
        <p class="mb-3">そのため、紫外線対策と同様に<strong>「シミ・シワ」を予防したい</strong>方にとっては、重要なスキンケアのひとつなのです。</p>
        <p>しかし、一般的には紫外線に関する正しい知識や対策が不足しているのが現状です。</p>
      </div>
    </div>

    <div class="mb-5 pt-5 text-center">
      <p class="mb-3">特に、紫外線が肌の老化を促進する主要因の一つであることや、<br>年間を通じた対策の必要性が十分に理解されていないのが現実です。</p>
      <p class="mb-3">では、適切な紫外線対策やアフターケアの方法、<br>効果的な成分はどのように選ぶとよいのでしょうか。</p>
      <p class="mb-3">そこで今回は「皮膚科医」＆「美容ナース」を対象に、<br>「エイジングケア×紫外線」に関する調査を実施しました。</p>
      <p>権威性のある「皮膚科医」＆「美容ナース」の調査内容から見えてくる、効果的な紫外線対策とは？</p>
    </div>
    
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <h3 class="mb-3">『シミ』『そばかす』『シワ』紫外線による肌ダメージは深刻！</h3>
        <p class="mb-3">まずは皆さんに「紫外線による肌ダメージは、どれくらい深刻だと思いますか？」と質問。</p>
        <p class="mb-3">約9割の方が<strong>『とても深刻（45.6％）』</strong>または<strong>『やや深刻（45.0％）』</strong>と回答する結果に。</p>
        <p class="mb-3">紫外線による肌ダメージは、多くの皮膚科医や美容ナースにとって深刻な問題であると認識されていることが明らかになりました。</p>
        <p class="mb-3">さらに「紫外線による肌ダメージは、どのようなものがありますか？（複数回答可）」と質問したところ以下の結果に。</p>
        <p class="mb-3"><strong>『シミ（63.3％）』<br>『そばかす（54.0％）』<br>『シワ（53.6％）』</strong></p>
        <p>紫外線は『シミ』や『シワ』などの老化現象に大きな影響を与えることが、皮膚科医や美容ナースの間で認識されていることがわかります。</p>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202502_03.jpg">
      </div>
    </div>
    
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202502_04.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <h3 class="mb-3">紫外線は肌が老化する原因と答えた皮膚科医・美容ナースは9割。</h3>
        <p class="mb-3">続いて、「紫外線は肌が老化する主な原因だと思いますか？」と質問したところ、</p>
        <p class="mb-3">約9割以上の方が<strong>『とてもそう思う（58.9％）』</strong>または<strong>『ややそう思う（36.9％）』</strong>と回答。</p>
        <p>紫外線が肌の老化に強く関与していると、大多数の皮膚科医・美容ナースの方が認識していることが示されました。</p>
      </div>
    </div>
    
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <h3 class="mb-3">紫外線が強くなる時期は『4月～6月』。しかし、紫外線対策は年中必要という声が大多数。</h3>
        <p class="mb-3">紫外線が強くなりはじめる時期<strong>『4月〜6月』</strong>と答える方が多いことから、紫外線対策を意識し始める時期として、春先から初夏にかけてが重要であることがわかります。</p>
        <p>しかし紫外線対策が必要な時期は<strong>『一年中（50.1％）』</strong>と回答した方が最も多く、季節を問わず継続的な紫外線対策が重要であるということが示されました。</p>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202502_05.jpg">
      </div>
    </div>
    
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202502_06.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <h3 class="mb-3">紫外線対策で『アフターケア』『日焼け止めの塗り直し』が不十分だということが明らかに</h3>
        <p class="mb-3">ここで皮膚科医・美容ナースに「紫外線対策として不十分だと思うものを教えてください（複数回答可）」と質問したところ、以下の回答に。</p>
        <p class="mb-3"><strong>『紫外線を浴びた後のアフターケアの不足（47.1％）』<br>『日焼け止めの塗り直しを徹底できていない（47.0％）』<br>『一年中紫外線対策をしない（46.8％）』</strong></p>
        <p class="mb-3">紫外線を浴びた後のアフターケアや、日焼け止めの適切な使用、そして一年間を通した継続的な対策が不足している点が浮き彫りに。</p>
        <p class="mb-3">さらに「紫外線対策において、一般的に理解されていないと思う点は何ですか？（複数回答可）」と質問。</p>
        <p class="mb-3"><strong>『紫外線対策をしっかり行うことで将来的なエイジングケアにもつながること（43.2％）』<br>『紫外線対策にはアフターケアも重要であること（41.4％）』<br>『紫外線対策を十分に行わないことで肌の老化を引き起こすこと（39.4％）』</strong></p>
        <p>紫外線対策が将来的なエイジングケアに直結することや、曇りの日や室内でも紫外線の影響を受けることなどが、一般的に十分には理解されていないことがわかります。</p>
      </div>
    </div>
    
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <h3 class="mb-3">通常のスキンケアアイテムだけで紫外線対策やエイジングケアは出来ない？</h3>
        <p class="mb-3">「通常のスキンケアアイテムだけで紫外線対策やエイジングケアはできると思いますか？」と質問したところ、<strong>『専用アイテムでのケアが必要（62.7％）』</strong>と回答した方が最も多く、<strong>『ある程度できるが不十分（35.4％）』</strong>と続きました。</p>
        <p class="mb-3">一般的なスキンケアだけでは紫外線対策やエイジングケアが十分でないと、多くの皮膚科医・美容ナースの方が認識していることは明らかですね。</p>
        <p class="mb-3">そこで気になるのは「紫外線対策やエイジングケアには、どのようなスキンケアアイテムがおすすめですか？（複数回答可）」という質問のアンサー。</p>
        <p class="mb-3"><strong>『成分にビタミンCを含んだもの（62.9％）』<br>『エイジングケア効果のあるもの（50.2％）』<br>『成分にナイアシンアミドを含んだもの（46.0％）』</strong></p>
        <p>ビタミンCやナイアシンアミドを含むスキンケアアイテムが、「紫外線対策」と「エイジングケア」の両面で重要視されていることが明らかになりました。</p>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202502_07.jpg">
      </div>
    </div>
    
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202502_08.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <h3 class="mb-3">おすすめの成分は「ナイアシンアミド」「ビタミンC誘導体」「ツボクサエキス」</h3>
        <p class="mb-3">最後に「肌のエイジングケア・紫外線対策におすすめの成分を教えてください（複数回答可）」と質問したところ</p>
        <p class="mb-3"><strong>『ナイアシンアミド（44.7％）』</strong>と回答した方が最も多く、<strong>『ビタミンC誘導体（40.8％）』『ツボクサエキス（39.7％）』</strong></p>
        <p>と続きました。<strong>『ナイアシンアミド』や『ビタミンC誘導体』『ツボクサエキス』</strong>は、肌のエイジングケアや紫外線対策において重要な成分として皮膚科医・美容ナースの方にとっても広く認識されていることがわかります。</p>
      </div>
    </div>
    
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_image w-50">
        <img src="@/assets/img/column/202502_09.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-50">
        <h2 class="mb-3">日焼け止めの塗り直しやアフターケアが不十分との声も多数。<br>エイジングケアと紫外線対策ができるアイテムはある？</h2>
        <p class="mb-3">今回の調査で、紫外線が肌のエイジングに大きな影響を与えるという認識が皮膚科医や美容ナースの間で広く認識されていることがわかりました。</p>
        <p class="mb-3">特に、紫外線による肌トラブルとしてあげられたのがシミ、そばかす、シワ。いずれも気になる方が多い肌の悩みですが、実際に専門的な方々もこれらを深刻な問題として捉えられていることは明らかです。</p>
        <p class="mb-3">また、紫外線の影響は春から強くなると考えられている一方で、対策の開始時期については一年中行うべきだと考える方が半数以上。</p>
        <p>しかし、一般の皆さんの実際の紫外線対策においては、日焼け止めの塗り直しやアフターケアが不十分だと考えている皮膚科医や美容ナースが多く、今後の情報啓発が求められます。</p>
      </div>
    </div>

    <div class="layer_01  my-5 py-5">
      <img src="@/assets/img/column/layer-bg_01.jpg">
      <div class="layer-text">
        <p class="mb-3 fs-2">若々しく健やかな肌を目指すために</p>
        <p class="mb-3">今回の調査から紫外線対策には、「ビタミンC」や「ナイアシンアミド」を含む<br>スキンケアアイテムが推奨されており、通常のスキンケアアイテムだけではなく、<br>専用アイテムの使用が必要であるという認識が強いことが明らかに。</p>
        <p class="mb-3">そして紫外線による肌ダメージやエイジングリスクに対する認識は<br>高まっているものの、具体的な対策が徹底されていないのが現状です。</p>
        <p class="mb-3">ナイアシンアミドやビタミンC誘導体、ツボクサエキスなどが<br>配合されたアイテムを使用して、エイジングケアや紫外線対策に<br>有効なアプローチを、はじめませんか。</p>
        <p class="mb-3">あなたが未来の自分のお肌も<br>好きでいれるように。</p>
        <p>そのお手伝いができるスキンケアアイテムを<br>マナビス化粧品は提案します。</p>
      </div>
    </div>

    <div class="text-center mb-5 pb-5">
      <p>アンケートの詳細は以下からご覧いただけます。</p>
      <p><a href="https://prtimes.jp/main/html/rd/p/000000011.000124389.html" target="_blank" title="https://prtimes.jp/main/html/rd/p/000000011.000124389.html">【9割の皮膚科医・美容ナースが警鐘！】紫外線による肌ダメージは深刻、年中対策が重要！<br>エイジングケア※には専用アイテムが必須？ナイアシンアミドとビタミンC誘導体が鍵に！</a></p>
    </div>

    <div class="rte">
      <font size="1">
        <p>調査概要：「エイジングケア×紫外線」に関する調査<br>
        【調査期間】2025年2月13日（木）～2025年2月17日（月）<br>
        【調査方法】リンクアンドパートナーズが提供する調査PR「PRIZMA」によるインターネット調査<br>
        【調査人数】1,073人<br>
        【調査対象】調査回答時に①皮膚科医／②美容ナースと回答したモニター<br>
        【モニター提供元】PRIZMAリサーチ<br>
        ※この調査の内容は、あくまでアンケート結果の紹介であり、効果や効能を実証するものではありません。</p>
      </font>
    </div>
    
  </section>


  <!-- トップに戻るボタン -->
  <button id="page-top" class="btn" v-on:click="scrollTop">
    TOP
  </button>

</template>

<style scoped>
.column_content h2,.column_content h3 {
  font-weight: 500 !important;
}
small {
  font-size: .7em;
}

.feature-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 50px;
}
.feature-row_item_image img {
  width: 100%;
}
.feature-row_item_text h3 {
  font-size: 1.25em;
}

button#page-top {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 100;
}


.layer_01 {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url('../../assets/img/column/layer-bg_01.jpg');
  background-size: cover;
  background-position: center;
  min-height: 500px; /* 最小高さを設定しておくと、極端に小さくなるのを防げます */
  padding: 20px; /* テキストと画像の端の間に余白を設定 */
}
.layer_01 img {
  display: none; /* 画像は背景として使用するので非表示にします */
}
.layer_01 .layer-text {
  padding: 10px;
  text-align: center;
  max-width: 90%; /* 文字が画像からはみ出さないように最大幅を設定 */
  word-wrap: break-word; /* 長い単語が折り返されるようにする */
  color: #424242;
  font-weight: 500;
}
.layer_01 .layer-text .fs-2 {
  font-size: 2em;
}

.feature-row_product_list {
  align-items: inherit;
  justify-content: flex-start;
}
.feature-row_column_list {
  align-items: inherit;
  justify-content: center;
}
.feature-row_product_item {
  width: 25%;
  padding: 5px;
  text-align: center;
}
.feature-row_column_item {
  width: 33%;
  padding: 5px;
  text-align: center;
}
.feature-row_product_detail {
  color: #333;
}
.feature-row_product_cate {
  font-size: .8em;
  color: #6b6b67;
  opacity: .65;
}
.feature-row_voice_list {
  align-items: baseline;
}
.feature-row_voice_list path.a {
  fill: none;
  stroke: #000;
  stroke-width: 2px;
}
.feature-row_voice_list .icon svg {
  width: 70px;
}
.feature-row_voice_list .feature-row_voice_item {
  width: 33%;
  padding: 5px;
  text-align: center;
}

.box-top-slide {
  position: relative;
}
.img-top-slide img {
  width: 100%;
  height: 422px;
  object-fit: cover;
}
.img-top-slide_text {
  position: absolute;
  bottom: 30px;
  left: 30px;
}
.img-top-slide_text h2 {
  font-size: 2em;
  font-weight: 500 !important;
}
.img-top-slide_text h2 span {
  font-size: .6em;
}

.layer_02 .layer-text,.layer_03 .layer-text,.layer_04 .layer-text {
  background-color: #cacaca;
  padding: 10px;
}
.layer_02 .layer-text .layer-text-inner,.layer_03 .layer-text .layer-text-inner,.layer_04 .layer-text .layer-text-inner {
  background-color: #fff;
  padding: 15px;
}
.layer_02 .layer-text .layer-text-inner h2 span,.layer_03 .layer-text .layer-text-inner h2 span,.layer_04 .layer-text .layer-text-inner h2 span {
  font-size: .6em;
}
@media screen and (min-width: 991px) {
    .layer_02 {
      position: relative;
      display: flex;
      align-items: flex-start;
      background-image: url('../../assets/img/column/202501_05.jpg');
      background-size: cover;
      min-height: 600px;
      padding: 60px;
    }
    .layer_03 {
      position: relative;
      display: flex;
      align-items: flex-start;
      background-image: url('../../assets/img/column/202501_06.jpg');
      background-size: cover;
      min-height: 600px;
      padding: 60px;
    }
    .layer_04 {
      position: relative;
      display: flex;
      align-items: flex-start;
      background-image: url('../../assets/img/column/202501_07.jpg');
      background-size: cover;
      min-height: 600px;
      padding: 60px;
    }
    .layer_02 img,.layer_03 img,.layer_04 img {
      display: none; /* 画像は背景として使用するので非表示にします */
    }
    .layer_02 .layer-text,.layer_03 .layer-text,.layer_04 .layer-text {
      padding: 15px;
      max-width: 45%; /* 文字が画像からはみ出さないように最大幅を設定 */
      word-wrap: break-word; /* 長い単語が折り返されるようにする */
      color: #424242;
      background-color: #fff;
    }
}
@media screen and (max-width: 699px) {
    .img-top-slide_text h2 {
      font-size: inherit;
    }
    .img-top-slide_text h2 span {
      font-size: .8em;
    }
}
@media screen and (min-width: 769px) {
   .feature-row_item_text_right {
    padding-left: 60px;
   }
   .feature-row_item_text_left {
    padding-right: 60px;
   }
   .w-40 {
    width: 40%;
   }
   .w-60 {
    width: 60%;
   }
   .feature-row.step .step-item {
    width: 33.33%;
   }
   .img-top-slide img {
    height: 650px;
   }
}
@media screen and (min-width: 1px) and (max-width: 768px) {
  .column_content h2 {
    margin-bottom: 40px;
  }
  .feature-row {
    flex-direction: column;
  }
  .feature-row_item_image {
    order: 1;
    margin-bottom: 15px;
  }
  .feature-row_item_text {
    order: 2;
  }
  .feature-row_voice_item, .feature-row_product_item, .feature-row_column_item {
      width: 100% !important;
  }
  .w-50, .w-25, .w-75 {
    width: 100% !important;
  }
  .layer-text {
    font-size: .8em;
  }
  .layer_01 .layer-text .fs-2 {
    font-size: 1.5em;
  }
}
</style>

<script>
import $ from "jquery";

$(function() {
 var topBtn = $('#page-top');    
 topBtn.hide();
 //スクロールが500に達したらボタン表示
 $(window).scroll(function () {
 if ($(this).scrollTop() > 500) {
 topBtn.fadeIn();
        } else {
 topBtn.fadeOut();
        }
    });
    
});

// ページ内リンク
export default{
  data: () => {
    return {isActive: []}
  },
  mounted (){
    window.scroll(0, 0);
    for(let i = 0; i < 2; i++) {
      this.isActive[i] = false
    }
  },
  methods: {
    scrollToAnchorPoint(refName) {
      const el = this.$refs[refName]
      el.scrollIntoView({ behavior: 'smooth'})
    },
    openInfo(ref) {
      console.log(ref)
      this.isActive[ref] = true
      console.log(this.isActive[ref])
    },
    closeInfo(ref) {
      console.log(ref)
      this.isActive[ref] = false
      console.log(this.isActive[ref])
    },
    scrollTop(){
      window.scrollTo({
      top: 0,
      behavior: "smooth"
      })
    }
  }
}

</script>